import { AlpineComponent } from '@alpinejs/csp';

const VideoStage = (): AlpineComponent => ({
  visible: false,
  playing: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'video-stage--visible' : '';
  },
  onPlay() {
    this.playing = true;
  },
  onPause() {
    this.playing = false;
  },
  onClick() {
    if (this.playing) {
      this.$refs.video.pause();
    } else {
      this.$refs.video.play();
    }
  },
  isNotPlaying() {
    return `display: ${!this.playing ? 'block' : 'none'}`;
  },
  isPlaying() {
    return `display: ${this.playing ? 'block' : 'none'}`;
  }
});

export default VideoStage;
